import React from "react";
import { useDashboardView } from "./Dashboard.hooks";
import { LandingPage } from "../LandingPage";
import Dashboard from "./Dashboard";
import { ComponentLoader } from "../../components";
import { useConfigView } from "../../Config.context";

function DashboardPage() {
  const { loading, showDashboard } = useDashboardView();
  const { config } = useConfigView();

  if (loading) {
    return <ComponentLoader height={"100vh"} />;
  }

  if (showDashboard) {
    return <Dashboard />;
  }

  return (
    <LandingPage
      imgUrl={
        config?.appName === "tinyEmail"
          ? "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/Workflow-email.svg"
          : "https://tinyemail-stripo.s3.ca-central-1.amazonaws.com/static/workflow/Workflow-albert.svg"
      }
    />
  );
}

export default DashboardPage;
